import { render, staticRenderFns } from "./MealToNeededPicker.vue?vue&type=template&id=1f80c3da&"
import script from "./MealToNeededPicker.vue?vue&type=script&lang=js&"
export * from "./MealToNeededPicker.vue?vue&type=script&lang=js&"
import style0 from "./MealToNeededPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports